import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {makeGetLocalApplication} from '../../../../store/data/localApplications/localApplicationsSelectors';
import {DevelopersApplicationsTableRow} from './developersApplicationsTableRow';

/*
 * Props.
 */

interface DevelopersApplicationsTableRowContainerProps {
  localApplicationId: number;
}

/*
 * Selectors.
 */

function getLocalApplicationId(_state: AppState, props: DevelopersApplicationsTableRowContainerProps) {
  return props.localApplicationId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<DevelopersApplicationsTableRowContainerProps>()(() => {
  const getLocalApplication = makeGetLocalApplication(getLocalApplicationId);
  return {
    localApplication: getLocalApplication,
  };
});

export const DevelopersApplicationsTableRowContainer = connect(mapStateToProps)(
  DevelopersApplicationsTableRow,
);
